import { mallTrack } from '../../../common_methods/track'
import { GlobalEnv } from '../../../global_env'
import { URLQueries } from '../../../global_env/url_query'
import { getTrackUrl } from '../../../../js/util'
import { is } from '@didi/webx-js'
import { MASErrorTrackCreateOrderFailed } from '../../../mas_error_track'
export const Track = {
  pageShow() {
    /* cspell: disable-next-line */
    mallTrack('c_trippackage_mall_detail_sw', '统计周期内具体套餐产品曝光量', {
      uid: GlobalEnv.loginInfo.uid,
      estimate_id: URLQueries.getQuery('estimate_id'),
      goods_id: URLQueries.getQuery('id'),
      position: 1,
      prev: URLQueries.getQuery('prev') || 0,
      workflow_id: GlobalEnv.eventParams
        ? GlobalEnv.eventParams.workflow_id
        : -1,
      inApp: __mpx_mode__ === 'web' && is('passenger') ? '01' : '02',
      is_spike: this.$data.$_.goods?.isSpike,
      channel: URLQueries.getQuery('dchn') || URLQueries.getQuery('channelId'),
      channel_id: GlobalEnv.channelId,
      act_id: URLQueries.getQuery('act_id') || -1,
      show_moudle: URLQueries.getQuery('show_version') || 0,
      is_free: this.$data.$_.goods?.creditInfo?.status,
      product_type: this.$data.$_.goods?.productType,
      role: this.$data.$_.group?.role,
      status: this.$data.$_.group?.flag,
      pintuan_type: this.$data.$_.cashback ? 2 : 1,
    })
  },
  btnClick(goods, group, arg) {
    mallTrack(
      /* cspell: disable-next-line */
      'c_trippackage_mall_detail_buy_ck',
      '统计周期内具体套餐点击立即购买点击量',
      {
        uid: GlobalEnv.loginInfo.uid,
        estimate_id: URLQueries.getQuery('estimate_id'),
        goods_id: URLQueries.getQuery('id'),
        product_type: goods.productType,
        workflow_id: GlobalEnv.eventParams
          ? GlobalEnv.eventParams.workflow_id
          : -1,
        inApp: __mpx_mode__ === 'web' && is('passenger') ? '01' : '02',
        is_spike: goods?.isSpike,
        type: arg.type,
        channel: GlobalEnv.channelId,
        channel_id: GlobalEnv.channelId,
        act_id: URLQueries.getQuery('act_id') || -1,
        driver_city_id: URLQueries.getQuery('driver_city_id'),
        url: getTrackUrl(),
        show_moudle: goods.showVersion,
        role: group?.role,
        status: group?.flag,
        pintuan_type: arg.cashback ? 2 : 1,
      }
    )
  },
  buySuccess(orderInfo) {
    const trackParams = {
      uid: GlobalEnv.loginInfo.uid,
      goods_id: URLQueries.getQuery('id'),
      package_id: URLQueries.getQuery('id'),
      dchn: URLQueries.getQuery('dchn'),
      product_type: this.$data.$_.goods.productType,
      package_type: this.$data.$_.goods.isSpike,
      type: 0,
      channel: GlobalEnv.channelId,
      channel_id: GlobalEnv.channelId,
      act_id: URLQueries.getQuery('act_id') || -1,
      g_BizId: this.$data.$_.goods.productType,
      package_species: this.$data.$_.goods.cateId,
      package_order_id: orderInfo?.order_id || orderInfo?.id,
    }
    if (GlobalEnv.isTrackCityId) {
      trackParams.omg_city_id = GlobalEnv.locationInfo?.cityId
    }
    mallTrack(
      /* cspell: disable-next-line */
      'c_trippackage_mall_detail_buy_suc_page_sw',
      '统计周期内具体套餐点击立即购买成功数量',
      trackParams
    )
  },
  viewMore() {
    /* cspell: disable-next-line */
    mallTrack('c_trippackage_mall_detail_moretaocan_ck', '乘客点击更多', {
      pid: GlobalEnv.loginInfo.uid,
      goods_id: URLQueries.getQuery('id'),
    })
  },
  /* cspell: disable-next-line */
  trippackagePaySw() {
    /* cspell: disable-next-line */
    mallTrack('c_trippackage_pay_sw', '套餐详情页-收银台页面-曝光', {
      pid: GlobalEnv.loginInfo.uid,
      goods_id: URLQueries.getQuery('id'),
    })
  },
}

export const createErrorTrack = (errno, error, orderId) => {
  if (errno !== undefined && errno !== 0) {
    if (window.Omega) {
      let msg = '没有错误 Message.'
      if (typeof error === 'string') {
        msg = error
      }
      if (error.message) {
        msg = error.message
      }
      if (error.msg) {
        msg = error.msg
      }
      if (error.errMsg) {
        msg = error.errMsg
      }
      MASErrorTrackCreateOrderFailed(msg, {
        source: 'goodsProcess',
        orderId,
        error,
      })
    }
  }
}
